import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { BookOpen } from "lucide-react";

export default function Insights() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { window.scrollTo(0, 0); }, []);
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/insights"); setItems(data); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <main data-testid="page-insights" className="pt-32 min-h-screen bg-[#FAFAF9]">
      <section className="max-w-[1440px] mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="flex items-center gap-3 text-[#A5854C] mb-8">
          <div className="hairline w-12"></div>
          <span className="font-mono text-[11px] uppercase tracking-[0.35em]">Market Insights</span>
        </div>
        <motion.h1
          initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9 }}
          className="font-serif font-light tracking-[-0.02em] text-[#0E1B2E] text-[44px] md:text-[80px] leading-[1] max-w-4xl"
        >
          Aviation research, <span className="italic text-[#A5854C]">plainly written.</span>
        </motion.h1>
      </section>

      <section className="border-t border-[#0E1B2E]/10">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-16">
          {loading ? (
            <div className="text-[#9AA3AE] font-mono text-[11px] uppercase tracking-[0.28em]" data-testid="insights-loading">Loading…</div>
          ) : items.length === 0 ? (
            <div data-testid="insights-empty" className="border border-dashed border-[#0E1B2E]/15 py-24 md:py-32 flex flex-col items-center justify-center text-center">
              <div className="w-16 h-16 border border-[#C8A97E]/50 rotate-45 flex items-center justify-center mb-8">
                <BookOpen className="text-[#A5854C] -rotate-45" size={24} />
              </div>
              <h3 className="font-serif text-[32px] md:text-[44px] text-[#0E1B2E] tracking-tight">First edition, in preparation.</h3>
              <p className="mt-4 max-w-md text-[#6B7684] text-[15px] leading-relaxed">
                Quarterly market reports and thematic research pieces are being finalised. Subscribe below to receive the first edition.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {items.map((a) => (
                <article key={a.id} className="border border-[#0E1B2E]/10 bg-white hover:border-[#A5854C] transition-colors">
                  {a.cover_image && <div className="aspect-[16/10] overflow-hidden"><img src={a.cover_image} alt={a.title} className="w-full h-full object-cover" /></div>}
                  <div className="p-6">
                    <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#A5854C]">{a.category}</span>
                    <h3 className="mt-3 font-serif text-[22px] text-[#0E1B2E] tracking-tight leading-tight">{a.title}</h3>
                    <p className="mt-3 text-[#6B7684] text-[14px] leading-relaxed">{a.excerpt}</p>
                    <div className="mt-6 font-mono text-[10px] uppercase tracking-[0.28em] text-[#9AA3AE]">{a.author}</div>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
